const getBadge = (game: GameFragment): GameBadgeType | null => {
  if (game?.isTrending) {
    return {
      type: "trending",
      color: "bg-destructive",
    };
  }
  if (game?.isHot) {
    return {
      type: "hot",
      color: "bg-black",
    };
  }
  if (game?.isNew) {
    return {
      type: "new",
      color: "bg-positive",
    };
  }
  if (game?.isHighRoller) {
    return {
      type: "high-roller",
      color: "bg-black",
    };
  }
  return null;
};

export default getBadge;
